import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
@Component({
    selector: 'inline-edit',
    templateUrl: './inline-edit.component.html',
    styleUrls: ['./inline-edit.component.css'],
})
export class InlineEditComponent implements OnInit, OnChanges {
    @Input() data: string;
    originalData: string;
    @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
    @Input() editmode: any;
    @Input() includePlainTextTab = false;
    editMode = false;
    index = false;
    constructor(public platform: LeftpanelComponent) {}
    htmlContent = '';
    // editorConfig: AngularEditorConfig = {
    //     editable: true,
    //     spellcheck: true,
    //     height: '15rem',
    //     minHeight: '5rem',
    //     placeholder: 'Enter text here...',
    //     translate: 'no',
    //     defaultParagraphSeparator: 'p',
    //     defaultFontName: 'system-ui',
    //     toolbarHiddenButtons: [
    //         ['bold']
    //     ],
    //     customClasses: [
    //         {
    //             name: "quote",
    //             class: "quote",
    //         },
    //         {
    //             name: 'redText',
    //             class: 'redText'
    //         },
    //         {
    //             name: "titleText",
    //             class: "titleText",
    //             tag: "h1",
    //         },
    //     ]
    // };
    editorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: 'auto',
        minHeight: '0',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        translate: 'yes',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Enter text here...',
        defaultParagraphSeparator: '',
        defaultFontName: '',
        defaultFontSize: '',
        fonts: [
            {class: 'arial', name: 'Arial'},
            {class: 'times-new-roman', name: 'Times New Roman'},
            {class: 'calibri', name: 'Calibri'},
            {class: 'comic-sans-ms', name: 'Comic Sans MS'}
        ],
        customClasses: [
            {
                name: 'quote',
                class: 'quote',
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: 'titleText',
                class: 'titleText',
                tag: 'h1',
            },
        ],
        uploadUrl: 'v1/image',
        sanitize: true,
        toolbarPosition: 'top',
        toolbarHiddenButtons: [
            ['bold', 'italic'],
            ['fontSize']
        ]
    };

    ngOnInit() {
        this.originalData = JSON.parse(JSON.stringify(this.data));
    }
    ngOnChanges() {
        if (this.editmode) {
            this.editmode = !this.editmode;
        }
    }
    onFocusOut() {
        if (this.editMode) {
            this.editMode = false;
            this.focusOut.emit(this.data);
        }
    }

    onCancel(){
        if (this.editMode) {
            this.editMode = false;
            this.data = this.originalData;
            this.focusOut.emit(this.data);

        }
    }

    tabChanged(value) {
        if (value.index !== 0) {
            this.index = true;
        } else {
            this.index = false;
        }
    }
}
